import { render, staticRenderFns } from "./intellectual-capital-panel.vue?vue&type=template&id=33d40fe3&"
var script = {}
import style0 from "./intellectual-capital-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports